module.exports = __webpack_public_path__ + "img/tranfer-new-feature.27ad8868.svg";